export enum MandatorParameterGroups {
  DEINKINOTICKET = 'DeinKinoTicket',
  CINETIXX_ABRECHNUNG = 'Cinetixx-Abrechnung',
  ONLINE = 'Online',
  NUMERO = 'Numero',
  WEB_MANAGER = 'Web Manager',
  WEB_CASH = 'Web-Cash',
  API = 'API',
  STADTGUTSCHEINE = 'Stadtgutscheine (zmyle)',
  ACARDO = 'Acardo'
}